import React, { Component, Fragment } from "react";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import "./App.css";
import Vote from "./Vote";
import Leaderboard from "./Leaderboard";

class App extends Component {
  state = {};

  render() {
    return (
      <Router>
        <div className="App">
          <header className="App-header">
            <h1 className="App-title">Irvine is the new Orange</h1>
            <h4>
              Orange just moved to the new office, no longer surrouneded by tatú
              parlors you find the need to get a tatú in commemoration of the
              old haunt. Asking the question.
            </h4>
            <h2>
              <span role="img" aria-label="tat">
                💪
              </span>What Would You Tatter?<span role="img" aria-label="tat">
                💪
              </span>
            </h2>
            <ul className="menu">
              <li>
                <Link to="/">Vote</Link>
              </li>
              <li>
                <Link to="/leaderboard">Leaderboard</Link>
              </li>
            </ul>
          </header>
          <Fragment>
            <Route exact path="/" component={Vote} />
            <Route path="/leaderboard" component={Leaderboard} />
          </Fragment>
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js